export default "__VITE_ASSET__3340eaa7__"